'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaAreaServicesPickerController = function () {
  function WinresOmalomaAreaServicesPickerController($scope, $rootScope, $filter) {
    _classCallCheck(this, WinresOmalomaAreaServicesPickerController);

    this.$scope = $scope;
    this.$scope.values = [];
    this.$rootScope = $rootScope;
    this.$filter = $filter;
    $scope._ = _;

    //this.$scope.textLength = 150;
  }

  _createClass(WinresOmalomaAreaServicesPickerController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$scope.$watch('$ctrl.dates', function (dates) {
        if (dates) {
          // dates.services
          // [TimeStamp1]: { Array of services }
          // [TimeStamp2]: { Array of services }
          _this.$scope.$watch(function () {
            return _this.services;
          }, function (serviceTimestamps) {
            var values = {};

            _.each(serviceTimestamps, function (services, timeStamp) {
              values[timeStamp] = _.map(services, function (service) {
                return _.cloneDeep(service.value);
              });
            });

            _this.values = values;
            _this.oldValues = _.cloneDeep(values);

            var beginDate = dates.BeginDate;
            var endDate = dates.EndDate;
            _this.initDatePicker(beginDate, endDate);
          });

          // Watch for changes to user selections
          _this.$scope.$watch(function () {
            return _this.values;
          }, function (values) {
            _this.updateValues(values);
            // const lines = this.generateProductLines(values);
            // this.$rootScope.$broadcast('update-area-checkboxes', values); // Invisible checkbox fix.
            // this.onChange({ value: lines });
          }, true);
          //var winres = this;
          //this.$scope.$on('update-area-checkboxes',(event,values)=>winres.$scope.values = values);
        }
      });

      this.$scope.$on('removerow', function (e, row) {
        return _this.removeRow(row);
      });
    }
  }, {
    key: 'removeRow',
    value: function removeRow(row) {
      var index = _.findIndex(this.services[row.timeStamp], function (service) {
        return service.data.DestinationInfo.DestinationCode === row.destinationCode && service.data.DestinationInfo.ProductCode === row.productCode;
      });

      var values = this.values[row.timeStamp];
      if (values) values = this.values[row.timeStamp][index];

      var oldValues = this.oldValues[row.timeStamp];
      if (oldValues) oldValues = this.oldValues[row.timeStamp][index];

      if (values) {
        if (Array.isArray(values)) {
          values[row.index] = oldValues[row.index];
        } else this.values[row.timeStamp][index] = this.oldValues[row.timeStamp][index];
      }
    }
  }, {
    key: 'updateValues',
    value: function updateValues(values) {
      var lines = this.generateProductLines(values);
      this.onChange({ value: lines });
    }
  }, {
    key: 'generateProductLines',
    value: function generateProductLines(valueTimestamps) {
      var _this2 = this;

      var rawLines = [];
      _.each(valueTimestamps, function (values, date) {
        _.each(values, function (value, i) {
          var service = _this2.services[date][i];
          if (!value) console.warn('[WOESP] value:', value);else if (!service) console.warn('[WOESP] service:', service);else rawLines.push(generateProductLine(value, service, date));
        });
      });
      var lines = _.filter(rawLines, function (line) {
        return line.Amount > 0;
      });
      console.log('[WOESP] Generated product lines:', lines);
      return lines;
    }
  }, {
    key: 'showMoreText',
    value: function showMoreText(service) {
      service.showMorelength = 999999;
      $('#showmorelink').hide();
    }
  }, {
    key: 'initDatePicker',
    value: function initDatePicker(beginDate, endDate) {
      var _this3 = this;

      this.$scope.datepicker_options = {
        showWeeks: false,
        minDate: new Date(),
        startingDay: 1,
        maxMode: 'day',
        minMode: 'day'
      };

      this.datePickerOpen = false;

      this.defaultBeginDate = new Date(beginDate);
      this.defaultEndDate = new Date(endDate);

      this.beginDate = new Date(beginDate);
      this.beginDateStamp = moment(this.beginDate).format("YYYYMMDD");

      this.$scope.datepicker_options.minDate = Date(beginDate);

      this.$scope.$watch('$ctrl.beginDate', function () {
        if (_this3.beginDate) {
          var m = new moment(_this3.beginDate);
          _this3.endDate = m.add(1, 'days').toDate();

          _this3.beginDateStamp = moment(_this3.beginDate).format("YYYYMMDD");
          _this3.$scope.services = _this3.services[_this3.beginDateStamp];
          _this3.$scope.values = _this3.values[_this3.beginDateStamp];

          _this3.updateReservableDateServices();
        }
      });
    }
  }, {
    key: 'updateReservableDateServices',
    value: function updateReservableDateServices() {
      var _this4 = this;

      _.each(this.services, function (service) {
        var beginDateMoment = moment(_this4.beginDate);
        var beginDate = beginDateMoment.toDate();
        var IsReservableByDate = beginDate >= _this4.defaultBeginDate && beginDate <= _this4.defaultEndDate;

        if (IsReservableByDate === true) service.IsReservableWithCurrentCriteria = service.DefaultIsReservableWithCurrentCriteria;else service.IsReservableWithCurrentCriteria = false;
      });
    }
  }, {
    key: 'toggleDatePicker',
    value: function toggleDatePicker() {
      this.datePickerOpen = !this.datePickerOpen;
    }
  }, {
    key: 'incrementDayForward',
    value: function incrementDayForward() {
      var m = new moment(this.beginDate);
      this.beginDate = m.add(1, 'days').toDate();
    }
  }, {
    key: 'incrementDayBackward',
    value: function incrementDayBackward() {
      var m = new moment(this.beginDate);
      this.beginDate = m.subtract(1, 'days').toDate();
    }
  }, {
    key: 'getReservabilityText',
    value: function getReservabilityText(service) {
      if (service.ReservabilityCheckResults.BeginDate) {
        return this.$filter('i18next')('omaloma.reservability.invalid_begin_date');
      } else if (service.ReservabilityCheckResults.CapacityAvailable) {
        return this.$filter('i18next')('omaloma.reservability.no_capacity');
      } else if (service.ReservabilityCheckResults.CapacityIsEnough) {
        return this.$filter('i18next')('omaloma.reservability.not_enough_capacity');
      } else if (service.ReservabilityCheckResults.CapacityRequired) {
        return this.$filter('i18next')('omaloma.reservability.capacity_required');
      } else if (service.ReservabilityCheckResults.ClosingDate) {
        return this.$filter('i18next')('omaloma.reservability.closing_date_error');
      } else if (service.ReservabilityCheckResults.Price) {
        return this.$filter('i18next')('omaloma.reservability.invalid_price');
      } else if (service.ReservabilityCheckResults.ReservablePrices) {
        return this.$filter('i18next')('omaloma.reservability.reservable_prices');
      }
    }
  }]);

  return WinresOmalomaAreaServicesPickerController;
}();

function generateProductLine(value, service, timeStamp) {

  var modes = {
    'select-amount': productLineFromSelectAmount,
    'select-passengers': productLineFromSelectPassengers,
    'select-prices': productLineFromSelectPrices
  };
  var func = modes[service.options.mode];
  if (!func) {
    var error = '[WOES] Unknown mode: ' + service.options.mode;
    console.error(error);
    throw error;
  }

  var productLine = func(value, service);

  // add to cart timestamp
  productLine.timeStamp = timeStamp;
  productLine.isAreaService = true;

  return productLine;
}

function productLineFromSelectAmount(value, service) {
  var data = service.data;
  var di = data.DestinationInfo;

  var priceSelections = _.filter(_.map([value], function (amount, i) {
    var change = amount - service.options.old;
    if (change == 0) return null;else if (change < 0) {
      // Don't allow adding negative amounts (removing reserved products)
      return null;
    }
    var price = service.options.prices[i];
    return {
      Price: price.Price,
      PriceIndex: price.Index,
      PriceLabel: price.Label,
      Amount: change,
      Index: i
    };
  }));

  var totalAmount = _.sumBy(priceSelections, function (s) {
    return s.Amount;
  });

  return {
    Name: service.name,
    Amount: totalAmount <= service.options.capacity ? totalAmount : 0,
    Price: service.Price,
    DestinationCode: di.DestinationCode,
    ProductCode: di.ProductCode,
    BeginDate: data.BeginDate,
    EndDate: data.EndDate,
    PriceSelections: priceSelections,
    ExtraQuestions: data.ExtraQuestions,
    // Not used when only amount is relevant
    PassengerAssignments: [],
    PriceGroup: null,
    BusStopID: null
  };
}

function productLineFromSelectPassengers(value, service) {
  var data = service.data;
  var di = data.DestinationInfo;

  var productIndex = 1;
  var passengerAssignments = _.filter(_.map(value, function (selected, i) {
    if (!selected || service.options.old[i]) return null;
    return {
      PassengerNumber: i,
      ProductNumber: productIndex++, // Not completely sure about this.
      Comment: null,
      Comment2: null
    };
  }));

  return {
    Name: service.name,
    Amount: passengerAssignments.length,
    DestinationCode: di.DestinationCode,
    ProductCode: di.ProductCode,
    BeginDate: data.BeginDate,
    EndDate: data.EndDate,
    PassengerAssignments: passengerAssignments,
    ExtraQuestions: data.ExtraQuestions,
    PriceSelections: null,
    PriceGroup: null,
    BusStopID: null
  };
}

function productLineFromSelectPrices(value, service) {
  var data = service.data;
  var di = data.DestinationInfo;

  var priceSelections = _.filter(_.map(value, function (amount, i) {
    var change = amount - service.options.old[i];
    if (change == 0) return null;else if (change < 0) {
      // Don't allow adding negative amounts (removing reserved products)
      return null;
    }
    var price = service.options.prices[i];

    return {
      Name: service.name,
      Price: price.Price,
      PriceIndex: price.Index,
      PriceLabel: price.Label,
      Amount: change,
      Index: i
    };
  }));

  var totalAmount = _.sumBy(priceSelections, function (s) {
    return s.Amount;
  });

  return {
    Name: service.name,
    Amount: totalAmount <= service.options.capacity ? totalAmount : 0,
    DestinationCode: di.DestinationCode,
    ProductCode: di.ProductCode,
    BeginDate: data.BeginDate,
    EndDate: data.EndDate,
    PassengerAssignments: null,
    ExtraQuestions: data.ExtraQuestions,
    PriceSelections: priceSelections,
    PriceGroup: null,
    BusStopID: null
  };
}

WinresOmalomaAreaServicesPickerController.$inject = ['$scope', '$rootScope', '$filter'];

_module3.default.component('winresOmalomaAreaServicesPicker', {
  template: require('./winresOmalomaAreaServicesPicker.html'),
  controller: WinresOmalomaAreaServicesPickerController,
  bindings: {
    services: '<',
    phone: '<',
    email: '<',
    dates: '<',
    onChange: '&'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaAreaServicesPicker/winresOmalomaAreaServicesPicker.js
// module id = 321
// module chunks = 2